import { hasNinetailedExperiences } from 'libs/experimentation/type-guards';

/**
 * Annotates a module with `hasExperiments` flag derived from `nt_experiences*`.
 *
 * Shared between the REST adapter (page fetch) and the Ninetailed REST fetcher
 * (variant fetch) so both pipelines emit the same shape contract to components.
 *
 * `Keyline` modules are stripped of all fields - they have no props.
 */
export function annotateModule(module: Record<string, unknown>): Record<string, unknown> {
  if (module.__typename === 'Keyline') {
    return { __typename: 'Keyline' };
  }
  return {
    ...module,
    hasExperiments: hasNinetailedExperiences(module),
  };
}
